/**
 * A utility function for conditionally joining classNames together
 * 
 * @example
 * // Basic usage:
 * cn('foo', 'bar'); // => 'foo bar'
 * cn('foo', { bar: true }); // => 'foo bar'
 * cn({ 'foo-bar': true }); // => 'foo-bar'
 * cn({ 'foo-bar': false }); // => ''
 * cn({ foo: true }, { bar: true }); // => 'foo bar'
 * cn({ foo: true, bar: false }); // => 'foo'
 * cn(null, false, 'bar', undefined, 0, 1, { baz: null }, ''); // => 'bar 1'
 */
export default function cn(...args: any[]): string {
  return args
    .filter(Boolean)
    .map((arg) => {
      if (typeof arg === 'string' || typeof arg === 'number') {
        return arg;
      }
      if (typeof arg !== 'object') {
        return '';
      }

      return Object.entries(arg)
        .filter(([, value]) => Boolean(value))
        .map(([key]) => key)
        .join(' ');
    })
    .join(' ');
}
